<script context="module" lang="ts">export { specification } from "./spec";
</script>

<script lang="ts">import { BaseAtom } from "components/cards/atoms";
export let container = undefined;
// ScorecardBase fields with no cricket override
export let paddingRoot = undefined;
export let paddingRootCompact = undefined;
export let gapRootCompact = undefined;
export let paddingRowCompact = undefined;
export let gapRowCompact = undefined;
export let gapPlayerCell = undefined;
export let txtSummaryRow = undefined;
// Cricket-overridden fields
export let gapRoot = undefined;
export let gapTabsStrip = undefined;
export let tabContainer = undefined;
export let selectedTabContainer = undefined;
export let txtTabLabel = undefined;
export let selectedTxtTabLabel = undefined;
export let sectionHeaderContainer = undefined;
export let txtSectionHeader = undefined;
export let txtColumnHeader = undefined;
export let paddingRow = undefined;
export let gapRow = undefined;
export let rowContainer = undefined;
export let txtPlayerName = undefined;
export let gapPlayerMeta = undefined;
export let gapMeta = undefined;
export let metaPillContainer = undefined;
export let txtMetaPill = undefined;
export let txtMetaText = undefined;
export let txtMetaTextSmall = undefined;
export let txtStatValue = undefined;
export let paddingSummaryRow = undefined;
export let gapSummaryRow = undefined;
export let summaryTotalRowContainer = undefined;
export let txtSummaryLabel = undefined;
export let txtSummaryDetail = undefined;
export let txtSummaryValue = undefined;
export let txtSummaryTotalLabel = undefined;
export let txtSummaryTotalValue = undefined;
// Cricket-only feed
export let innings = undefined;
export let selectedInningIndex = undefined;
export let singleColumnMode = undefined;
// Cricket-only bowling section overrides
export let sectionHeaderBowlingContainer = undefined;
export let txtSectionHeaderBowling = undefined;
export let txtColumnHeaderBowling = undefined;
// Cricket-only fall of wickets footer
export let paddingFallOfWickets = undefined;
export let txtFallOfWickets = undefined;
</script>

<BaseAtom
  _isotope="CricketScorecardCardAtom"
  {...container}
  _cssVariablePrefix="cricket-scorecard-card"
>
  cricket scorecard card
</BaseAtom>

<style>
  .cricket-scorecard-card {
    width: 100%;
  }</style>
